import { inject, Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { PaymentService } from '@services/payment/payment.service';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { MatButtonModule } from '@angular/material/button';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';
import { PaymentSipUpiTimerComponent } from '../payment-sip-upi-timer/payment-sip-upi-timer.component';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';

@Component({
  selector: 'app-quicdonate_carousel',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    MatButtonModule,
    NgxGlideModule,
    CurrencyIconComponent,
    MatIconModule,
    PaymentSipUpiTimerComponent
  ],
  templateUrl: './quicdonate_carousel.component.html',
  styleUrls: ['./quicdonate_carousel.component.scss']
})
export class QuickDonateCarouselComponent {

  public vars = inject(VariablesService);
  public vwo = inject(VwoService);
  public util = inject(UtilService);
  public paymentService = inject(PaymentService);
  public paymentV2 = inject(PaymentV2Service);
  @Input() currency = 'INR';
  isMobile = this.vars.isMobile;
  isIos;

  user;
  lastPaymentmode = [];

  ngOnInit() {
    this.isIos = this.util.isIOSDevice();

    this.vars.userData.subscribe(res => {
      this.user = res;
      if (this.user) {
        this.getPaymentOptionsforQD(this.currency);
      }
    })
  }

  getPaymentOptionsforQD(currency) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.vars.isMobile ? 1 : 0}&amount=${this.user?.lastorder?.donated_amount_local}`;
    if (this.vars.utmsUrlString) params += `&${this.vars.utmsUrlString}`;
    this.paymentService.getPaymentOptions(currency, params).subscribe((res: any) => {
      if (this.vwo.new_upi_AB() && res?.data?.options) res.data.options['vpa_collect_enabled'] = false;
      if (res?.data?.options?.PREVPAYGATEWAYRECOMM) {
        Object.keys(res?.data?.options?.PREVPAYGATEWAYRECOMM).sort().reverse().slice(0,3).forEach((k,j) => {
          if (!(res?.data?.options?.PREVPAYGATEWAYRECOMM[k].payment_mode === 'UPI' && res?.data?.options?.PREVPAYGATEWAYRECOMM[k].payment_mode_value !== 'VPA' && (this.isIos || !this.isMobile))) {
            this.lastPaymentmode.push(res?.data?.options?.PREVPAYGATEWAYRECOMM[k])
            if (this.lastPaymentmode[j]?.checksum?.name) {
              const arr = res?.data?.options?.PREVPAYGATEWAYRECOMM[k]?.checksum?.name.toLowerCase().split(" ");
              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }
              this.lastPaymentmode[j].checksum.name = arr.join(" ")
            }
          }
        });
      }
      else {
        this.lastPaymentmode = null;
      }
    });
  }

  donate(i) {
    this.vars.otdpayment.next({'paymode' : this.lastPaymentmode[i], 'amount': this.lastPaymentmode[i].amount})
  }
}
